"use client";
import React, { createContext, useContext, useEffect, useState } from "react";
import socketIOClient from "socket.io-client";
import { UserContext } from "./UserContext";
import { celebApi } from "@/services/api";

export const SocketContext = createContext<any>(null);

const ENDPOINT = celebApi ?? "";

export const SocketProvider = ({ children }: any) => {
  const { currentUser, userToken } = useContext(UserContext);
  const [socket, setSocket] = useState(null);

  const userId = currentUser?._id || null;

  useEffect(() => {
    if (userId && userToken) {
      const newSocket: any = socketIOClient(ENDPOINT, {
        query: { token: userToken },
        transports: ["websocket", "polling"],
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 1000,
      });
      setSocket(newSocket);

      return () => newSocket.close();
    } else {
      setSocket(null);
    }
  }, [userId, userToken]);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};

export default SocketProvider;
